import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { ErrorType, getErrorDescription, getErrorTitle } from 'type/ErrorType'

export const FailedBottom = observer(() => {
  const error: ErrorType = 'generation-failed'
  const size = opt.stand ? 20 : opt.tsum ? 15 : 13

  return (
    <Vertical center>
      <Typo size={size} upper medium center error>
        {getErrorTitle(error)}
      </Typo>
      <Typo size={size} pre secondary center error>
        {getErrorDescription(error)}
      </Typo>
    </Vertical>
  )
})
